import React from 'react';
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import TimerIcon from '@material-ui/icons/Timer';
import {convertSecondsToMinutesSecondsFormat} from "../../../common/Util";

const useStyles = makeStyles(theme => ({

    gridExterno: {
        display: 'flex',
        flexDirection:'column',
        flexwrap: 'nowrap',
        flexGrow: 3,
        backgroundColor: 'white',
        margin: '4px',
        // padding: '4px',
        borderRadius: '15px',
        minHeight: '150px',
        width: '120px'

    },
    mainGrid: {
        display: 'flex',
        flexDirection:'row',
        flexwrap: 'wrap',
        flexGrow: 12,
       // alignSelf: 'stretch',
    },

    nomeEtapa: {
        //backgroundColor: 'red',
        display: 'flex',
        justifyContent: 'center',
        alignSelf: 'center',
        borderBottom: '1px solid red'
    },
    valoresArea: {
      //  backgroundColor: 'green'
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',

    },
    fila: {
        display: 'flex',
        flexDirection: 'column',
        justifyItems: 'center',
        alignItems: 'center',
        alignSelf: 'center'
    },
    concluidos: {
        display: 'flex',
        flexDirection: 'column',
        justifyItems: 'center',
        alignItems: 'center',
        alignSelf: 'center'
    },
    tempomedio: {
        display: 'flex',
        flexDirection: 'row',
        justifyItems: 'center',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        alignSelf: 'center',
        fontSize:'2rem'
    },
    tempoLabel: {
        display: 'flex',
        flexDirection: 'row',
        justifyItems: 'center',
        justifyContent: 'flex-end',
        paddingTop: '2px'
    },
    tempoValor: {
        display: 'flex',
        flexDirection: 'row',
        justifyItems: 'center',
        justifyContent: 'space-evenly'

    }


}));

    const Autoclave = ({ foto, tempo, index }) => {

    const classes= useStyles();



        return (
            <Grid item container className={classes.gridExterno} xs={3} sm={3} md={3} lg={3} xl={3}>
                <Grid container item className={classes.mainGrid} xs={12} sm={12} md={12} lg={12} xl={12}>



                </Grid>
            </Grid>



        )
    }

export default Autoclave;


